import { Action, Reducer } from 'redux';

// functions
import * as Functions from '../../functions/common';

// Actions
import * as Actions from '../actions';
import { ProtocolPractitionersState, ProtocolPractitionersUnloadState } from '../states/ProtocolPractitionersState';

type KnownAction =
    | Actions.ProtocolPractitioners.ProtocolPractitiones_GetAll_Request_Action
    | Actions.ProtocolPractitioners.ProtocolPractitiones_GetAll_Receive_Action
    | Actions.ProtocolPractitioners.ProtocolPractitiones_GetAll_Fail_Action
    | Actions.ProtocolPractitioners.ProtocolPractitionesStudyTask_GetAll_Request_Action
    | Actions.ProtocolPractitioners.ProtocolPractitionesStudyTask_GetAll_Receive_Action
    | Actions.ProtocolPractitioners.ProtocolPractitionesStudyTask_GetAll_Fail_Action
    | Actions.ProtocolPractitioners.ProtocolPractitionerExportExcel_Request_Action
    | Actions.ProtocolPractitioners.ProtocolPractitionerExportExcel_Success_Action
    | Actions.ProtocolPractitioners.ProtocolPractitionerExportExcel_Fail_Action
    | Actions.ProtocolPractitioners.ProtocolPractitionerHcProtocolPatientsGetAllRequestAction
    | Actions.ProtocolPractitioners.ProtocolPractitionerHcProtocolPatientsGetAllReceiveAction
    | Actions.ProtocolPractitioners.ProtocolPractitionerHcProtocolPatientsGetAllFailAction;

export const ProtocolPractitionersReducer: Reducer<ProtocolPractitionersState> = (
    state: ProtocolPractitionersState | undefined,
    incomingAction: Action
  ): ProtocolPractitionersState => {
    if (state === undefined) {
      return ProtocolPractitionersUnloadState;
    }
  
    const action = incomingAction as KnownAction;

    switch (action.type) {
        case 'PROTOCOL_PRACTITIONERS_GETALL_REQUEST_ACTION':
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: undefined,
                failOnLoadingAll: false,
                error: undefined
            };
        case 'PROTOCOL_PRACTITIONERS_GETALL_RECEIVE_ACTION':
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined
            };
        case 'PROTOCOL_PRACTITIONERS_GETALL_FAIL_ACTION':
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: action.error
            };
        case 'PROTOCOL_PRACTITIONERS_STUDYTASK_GETALL_REQUEST_ACTION':
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: undefined,
                failOnLoadingAll: false,
                error: undefined
            };
        case 'PROTOCOL_PRACTITIONERS_STUDYTASK_GETALL_RECEIVE_ACTION':
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                error: undefined
            };
        case 'PROTOCOL_PRACTITIONERS_STUDYTASK_GETALL_FAIL_ACTION':
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: action.error
            };
        case 'PROTOCOL_PRACTITIONERS_EXPORTEXCEL_REQUEST_ACTION':
            return {
                ...state,
                isExportingExcel: true,
                successExportingExcel: undefined,
                failOnExportingExcel: false
            };
        case 'PROTOCOL_PRACTITIONERS_EXPORTEXCEL_SUCCESS_ACTION':
            return {
                ...state,
                isExportingExcel: false,
                successExportingExcel: true,
                failOnExportingExcel: false
            };
        case 'PROTOCOL_PRACTITIONERS_EXPORTEXCEL_FAIL_ACTION':
            return {
                ...state,
                isExportingExcel: false,
                successExportingExcel: false,
                failOnExportingExcel: true,
                error: action.error
            };
        case 'PROTOCOL_PRACTITIONERS_HCPROTOCOLPATIENTS_GETALL_REQUEST_ACTION':
            return {
                ...state,
                isLoadingHcProtocolPatients: true,
                successLoadingHcProtocolPatients: undefined,
                failOnLoadingHcProtocolPatients: false,
                error: undefined
            };
        case 'PROTOCOL_PRACTITIONERS_HCPROTOCOLPATIENTS_GETALL_RECEIVE_ACTION':
            return {
                ...state,
                hcProtocolPatients: action.hcProtocolPatients,
                isLoadingHcProtocolPatients: false,
                successLoadingHcProtocolPatients: true,
                failOnLoadingHcProtocolPatients: false,
                error: undefined
            };
        case 'PROTOCOL_PRACTITIONERS_HCPROTOCOLPATIENTS_GETALL_FAIL_ACTION':
            return {
                ...state,
                isLoadingHcProtocolPatients: false,
                successLoadingHcProtocolPatients: false,
                failOnLoadingHcProtocolPatients: true,
                error: action.error
            };
        default:
            return state;
    }
}
    